import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

const PageHelmet = ({
  title = 'Dashboard',
  description = 'Track and manage your campaigns with TraQR.',
  url = process.env.REACT_APP_COGNITO_REDIRECT_URL,
}) => (
  <Helmet>
    <title>{`TraQR - ${title}`}</title>

    <meta property="og:title" content={`TraQR - ${title}`} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={url} />
  </Helmet>
)

PageHelmet.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
}
export default PageHelmet;
